import { getRoot, IStateTreeNode } from 'mobx-state-tree';
import { IRootStore } from '@stores/RootStore';
import { IMainStore } from './types';

export const withMainStore = (self: IStateTreeNode) => {
  return {
    views: {
      get mainStore(): IMainStore {
        return getRoot<IRootStore>(self).mainStore;
      },
    },
  };
};
